export const logs_index = ['logs.index']
export const logs_detail = ['logs.detail']

export default [].concat(
    logs_index,
    logs_detail
)